import {Upload} from "./Upload";
import {ValidationTypes} from "../core/Validator";
import {FormatTypes} from "../core/Formater";

export abstract class BaseModel {

	id: number | string;
	tableData?: any;
	uploads?: Upload[]
}

export class BaseModelDescriptor {
	id: AttributeDescriptor = {validation: []}
}

export interface AttributeDescriptor {
	validation: ValidationTypes[]
	format?: FormatTypes
}
